import axios from "axios";

const map = {
    state: {
        URL: "https://restapi.amap.com/",
        KEY: "c76f5341624ba08bbf94b258ca02bf8a"
    },
    actions: {
        getMapData(store, request) {
            // 配置请求参数
            var type = request.type;                                    // 请求类型
            var url = request.url;                                      // 请求名称
            var data = request.data ? request.data : "";                // 请求数据
            var config = "?key=" + store.state.KEY + "&" + data;        // 请求参数

            // 配置传递参数
            var config;
            switch (type) {
                default:
                    config = {
                        method: "get",
                        headers: { "Content-Type": "application/json" },
                        timeout: 10000,
                        baseURL: store.state.URL,
                        url: url + config,
                    };
                    break;
            }

            return axios(config);
        }
    }
};

export default map;



// WEBPACK FOOTER //
// ./src/store/modules/map.js